import { useParams } from 'react-router-dom';

import _data from './info.json';
import ProjectPanel from './ProjectPanel';
import { DataType } from './types';
import { MyParams } from './root';
import usePageMeta from './usePageMeta';

const data = _data as DataType;

export default function ProjectPage() {
  const { projectId } = useParams<MyParams>();
  const index = parseInt(projectId ?? '0');
  const project = data.projects[index];

  const pageTitle = project ? [project.title, project.year].filter(Boolean).join(', ') : 'Work';
  const description = project?.description
    ? project.description.slice(0, 300)
    : 'Objects in neon, glass and ceramics by Yoav Reches, a designer and maker based in Berlin.';

  usePageMeta(pageTitle, description, `work/${index}`);

  return <ProjectPanel data={data} projectId={index} />;
}
